module.exports = "pegasus/assets/finability.png";